/** Surfaces that can be gated by the onboarding 30‑min lock (quiz funnels). */
export type OnboardingLockTarget = "palmistry_tab" | "compatibility_tab"

/**
 * Map funnel quiz registry key → lock target.
 * Soulmate / Astro Map quizzes no longer use this — their unlock timer is driven
 * by included main-plan entitlement via report-unlock (30→10 min).
 * Unknown / missing keys return null (no onboarding lock).
 */
export function mapQuizToLockTarget(quizId: string | null): OnboardingLockTarget | null {
  if (!quizId) return null

  switch (quizId) {
    case "simplified":
    case "palmistry":
    case "demo":
      return "palmistry_tab"
    case "compatibility":
      return "compatibility_tab"
    default:
      return null
  }
}
